import Layout from "../../components/Layout";
import { Helmet } from "react-helmet-async";
import {
  FiUsers,
  FiClipboard,
  FiDollarSign,
  FiBarChart2,
  FiSettings,
  FiBriefcase,
  FiCheckCircle,
} from "react-icons/fi";

const IndustryEducation = () => {
  const trackCTA = () => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "Sign Up - Education Industry Page",
      });
    }
  };

  return (
    <Layout>
      <Helmet>
        <title>Education Industry | RedERP</title>
        <meta name="description" content="Empower educational institutions with streamlined management, billing, and communication tools through RedERP." />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white py-20">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="flex-1 text-left">
            <h1 className="text-4xl font-bold mb-4">Smarter Management for Modern Education</h1>
            <p className="mb-6 text-sm sm:text-base">
              Whether you're managing a school, university, or training center, RedERP brings clarity, automation, and integration to every department.
            </p>
            <a
              href="https://app.rederp.pro/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackCTA}
              className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
            >
              Get Started Now
            </a>
          </div>
          <div className="flex-1 hidden md:flex justify-end">
            <img
              src="/assets/images/education-industry.png"
              alt="Education Industry Illustration"
              className="w-[400px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto text-center mb-10">
          <h2 className="text-3xl font-bold text-primary mb-3">Key Modules for Educational Institutions</h2>
          <p className="text-gray-600">
            Improve resource planning, student engagement, and administrative efficiency using RedERP’s industry-ready modules.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-left max-w-6xl mx-auto">
          {[
            {
              icon: <FiUsers size={24} />,
              title: "Human Resources",
              desc: "Manage faculty and staff contracts, leaves, payroll, and performance tracking from a unified system.",
            },
            {
              icon: <FiClipboard size={24} />,
              title: "Project Management",
              desc: "Coordinate curriculum development, campus events, or training sessions with real-time task tracking.",
            },
            {
              icon: <FiDollarSign size={24} />,
              title: "Finance & Billing",
              desc: "Automate student fee invoices, track payments, generate receipts, and gain financial clarity.",
            },
            {
              icon: <FiBarChart2 size={24} />,
              title: "BI & Reporting",
              desc: "Track student admissions, budget vs. actuals, department KPIs, and funding reports from dynamic dashboards.",
            },
            {
              icon: <FiSettings size={24} />,
              title: "CRM & Communication",
              desc: "Engage with students and guardians, manage inquiries, open days, and automate follow-ups and feedback.",
            },
            {
              icon: <FiBriefcase size={24} />,
              title: "Asset & Facility Management",
              desc: "Manage labs, classrooms, equipment, and digital assets — including maintenance and lifecycle tracking.",
            },
          ].map((mod, i) => (
            <div
              key={i}
              className="p-6 bg-gray-50 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-3 text-primary mb-3">
                {mod.icon}
                <h3 className="font-bold">{mod.title}</h3>
              </div>
              <p className="text-sm text-gray-600">{mod.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-10 py-16">
          <div className="flex-1 text-left">
            <h3 className="text-3xl font-bold mb-4">RedERP for Educational Excellence</h3>
            <p className="mb-6 text-sm sm:text-base">
              Try RedERP today and transform the way your school or university operates — from administration to classrooms.
            </p>
            <a
              href="https://app.rederp.pro/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackCTA}
              className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
            >
              Try RedERP for Education
            </a>
          </div>
          <div className="flex-1 hidden md:flex justify-end">
            <img
              src="/assets/images/cta2.png"
              alt="Education CTA"
              className="w-[360px] object-contain"
            />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default IndustryEducation;
